<p-confirmDialog></p-confirmDialog>

<div [ngClass]="{ 'flex flex-col gap-4 frame pb-5 my-2': true, 'border-red-500': globalError | async }">
  <!-- Action Buttons -->
  <div class="flex gap-4 items-center bg-surface-50 dark:bg-surface-800 rounded-t-lg p-5">
    <p-button type="button" [label]="'milestone.form.add_funding' | translate" (onClick)="addFunding()" [disabled]="disabled | async">
      <i class="pi pi-plus"></i>
    </p-button>

    <p-button
      type="button"
      [label]="'common.text_groups.remove_all' | translate"
      (onClick)="clearAllFundings()"
      severity="secondary"
      [disabled]="(disabled | async) || fundings.length === 0">
      <i class="pi pi-trash"></i>
    </p-button>
  </div>

  <!-- Funding Entries -->
  <div class="flex flex-col gap-0.5">
    <div *ngFor="let item of fundings; let i = index; trackBy: trackByFn">
      <div class="flex flex-row gap-5 p-5 justify-center items-center">
        <div class="flex flex-col gap-4 w-full">
          <div class="flex flex-col xl:flex-row gap-4 w-full items-start">
            <!-- Source Financement Dropdown -->
            <div class="flex flex-col gap-2 w-full xl:w-2/5">
              <label [for]="'financial_source-' + uid + i" class="text-xs font-bold">
                {{ 'milestone.form.financial_source' | translate }}
              </label>
              <p-select
                [options]="financialSourcesOptions"
                optionLabel="name"
                optionValue="code"
                dataKey="code"
                appendTo="body"
                [showClear]="true"
                [placeholder]="'milestone.form.placeholders.financial_source' | translate"
                [ngModel]="item['sourceFinancement'].id"
                (ngModelChange)="updateSourceFinancement(i, $event)"
                [disabled]="!!(disabled | async)"
                [class.ng-invalid]="(errors | async)?.[i]?.sourceFinancement"
                [class.ng-dirty]="(errors | async)?.[i]?.sourceFinancement"
                class="w-full">
              </p-select>
              <p class="text-xs text-red-500 font-bold" *ngIf="(errors | async)?.[i]?.sourceFinancement || ''">
                {{ (errors | async)?.[i]?.sourceFinancement }}
              </p>
            </div>

            <!-- Monnaie Dropdown -->
            <div class="flex flex-col gap-2 w-full xl:w-2/5">
              <label [for]="'currency-' + uid + i" class="text-xs font-bold">
                {{ 'milestone.form.currency' | translate }}
              </label>
              <p-select
                [options]="currencyOptions"
                optionLabel="name"
                optionValue="code"
                dataKey="code"
                appendTo="body"
                [showClear]="true"
                [placeholder]="'milestone.form.placeholders.currency' | translate"
                [ngModel]="item['monnaieId']"
                (ngModelChange)="updateMonnais(i, $event)"
                [disabled]="!!(disabled | async)"
                [class.ng-invalid]="(errors | async)?.[i]?.monnaieId"
                [class.ng-dirty]="(errors | async)?.[i]?.monnaieId"
                class="w-full">
              </p-select>
              <p class="text-xs text-red-500 font-bold" *ngIf="(errors | async)?.[i]?.monnaieId || ''">
                {{ (errors | async)?.[i]?.monnaieId }}
              </p>
            </div>

            <!-- Budget Input -->
            <div class="flex flex-col gap-2 w-full xl:w-1/5">
              <label [for]="'budget-' + uid + i" class="text-xs font-bold">
                {{ 'milestone.form.funding_budget' | translate }}
              </label>
              <p-inputnumber
                mode="decimal"
                fluid
                minFractionDigits="0"
                maxFractionDigits="2"
                [ngModel]="item.budgetEstimer"
                (ngModelChange)="updateBudget(i, $event)"
                [disabled]="!!(disabled | async)"
                [class.ng-invalid]="(errors | async)?.[i]?.budgetEstimer"
                [class.ng-dirty]="(errors | async)?.[i]?.budgetEstimer"
                class="w-full">
              </p-inputnumber>
              <p class="text-xs text-red-500 font-bold" *ngIf="(errors | async)?.[i]?.budgetEstimer || ''">
                {{ (errors | async)?.[i]?.budgetEstimer }}
              </p>
            </div>
          </div>
        </div>

        <!-- Remove Button -->
        <div class="mt-5">
          <button type="button" (click)="removeFunding(i)" [disabled]="disabled | async">
            <i [ngClass]="['pi pi-eraser', disabled ? 'text-gray-200' : 'hover:text-red-500']"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
